import http from "../../http-common";

class CatalogTabsService {
    getCatalogTabs(path: string, pageNumber: number) {
        return http.get(`/education/catalog/tabs/${path}?pageNumber=${pageNumber}`);
    }
}

export default new CatalogTabsService();
